import React from 'react'
import styled from 'styled-components';
import { Color, Colors } from '../styles/Colors';

const Wrapper = styled.label`
    // Creates the outer wrapper, provides the positioning ref for the absolute positioned span
    position: relative;  
    display: inline-block; 
    width: ${({ $size }) => ($size === 'medium' ? '44px' : '30px')}; 
    height: ${({ $size }) => ($size === 'medium' ? '24px' : '17px')}; 

    // Visually hide the checkbox (the input still controls the checked state) 
    & > input {
        opacity: 0; 
        width: 0; 
        height: 0; 
    }

    // The switch track (fills the 30*17 label)
    & > span {
        position: absolute; 
        cursor: pointer; 
        top: 0;
        bottom: 0; 
        left: 0; 
        right: 0; 
        background-color: ${Color(Colors.darkGray)}; 
        -webkit-transition: .4s; 
        transition: .4s; 
    }

    // The movable circular knob 
    & > span:before {
        position: absolute; 
        content: ""; 
        height: ${({ $size }) => ($size === 'medium' ? '20px' : '13px')}; 
        width: ${({ $size }) => ($size === 'medium' ? '20px' : '13px')}; 
        left: 2px; 
        bottom: 2px; 
        background-color: ${Color(Colors.white)}; 
        -webkit-transition: .2s; 
        transition: .2s; 
    }

    // While checkbox is checked the track (span) becomes blue 
    & > input:checked + span {
        background-color: ${Color(Colors.blue)}; 
    }

    & > input:focus + span {
        box-shadow: 0 0 1px ${Color(Colors.blue)}; 
    }

    & > input:checked + span:before {
        -webkit-transform: translateX(${({ $size }) => ($size === 'medium' ? '20px' : '13px')});
        -ms-transform: translateX(${({ $size }) => ($size === 'medium' ? '20px' : '13px')});
        transform: translateX(${({ $size }) => ($size === 'medium' ? '20px' : '13px')})
    }

    & > span {
        border-radius: ${({ $size }) => ($size === 'medium' ? '24px' : '17px')};
    }

    & > span:before {
        border-radius: 50%;
    }
`;

const SwicthButton = ({ checked, onChange, size}) => {
    return (
        <Wrapper $size={size}>
            <input
                type='checkbox'
                checked={checked}
                onChange={onChange}
            />
            <span></span>
        </Wrapper>
    )
}

export default SwicthButton
